/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { useState } from "react";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import StoreHours from "0.Mine/0.Components/BusinessCard/Employee/Container/BusinessEmployeeHours";
import BusinessEmployees from "0.Mine/0.Components/BusinessCard/Employee/UI/BusinessEmployees";
import BusinessSchedule from "0.Mine/0.Components/BusinessCard/Hours/Container/BusinessSchedule";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";

// Argon Dashboard 2 PRO MUI example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

// NewProduct page components
import Header from "layouts/ecommerce/products/new-product/components/Header";

import BusinessPageTemplate from "./BusinessTemplate";

// Images
const bgImage =
  "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/profile-layout-header.jpg";

function EditBusinessHours() {
  return (
    <BusinessPageTemplate>
      <BusinessSchedule />
    </BusinessPageTemplate>
  );
}

export default EditBusinessHours;
